export class SliderManager {
    constructor() {
        this.logoSlider();

        this.investmentsSlider();
    }

    logoSlider() {
        const self = this;
        const logosResponsive = {
            0: {
                items: 1
            },
            300: {
                items: 2
            },
            450: {
                items: 3
            },
            500: {
                items: 3
            },
            600: {
                items: 5
            },
            1000: {
                items: 6
            }
        };

        $( '.logo-slider' ).each( function() {
            self.initSlider( '.logo-slider', '.logo-slider .item', 5, logosResponsive );
        } );
    }

    investmentsSlider() {
        $( '.investments-slider' ).owlCarousel( {
            navigation: false,
            pagination: true,
            loop: true,
            autoplay: true,
            autoplayTimeout: 7000,
            autoplayHoverPause: true,
            autoPlay: 7000,
            stopOnHover: true,
            items: 1,
            itemsScaleUp: false,
            responsiveClass: true,
            responsive: {}
        } );
    }

    initSlider( selector, innerSelector, slidesToShow, responsiveArgs = {}, autoplay = false ) {
        let innerItems = $( innerSelector ).length;
        if ( innerItems > slidesToShow ) {
            $( selector ).owlCarousel( {
                navigation: false,
                pagination: false,
                loop: true,
                autoplay: true,
                autoplayTimeout: 7000,
                autoplayHoverPause: true,
                autoPlay: 7000,
                stopOnHover: true,
                items: slidesToShow,
                itemsScaleUp: false,
                responsiveClass: true,
                responsive: responsiveArgs
            } );
        }
    }
}
